export const Benefits = () => (
  <>
    <h1>Benefits we offer</h1>
    <section>
      <div className="card">
        <ul>
          <li>
            <p>
              <strong>Time Saving</strong>
              <br />
              Our service frees up valuable time that you can devote to other
              priorities such as work, family, or personal interests.
            </p>
          </li>
          <li>
            <p>
              <strong>Consistent Cleaning</strong>
              <br />
              We help maintain a consistently clean and organized living
              environment, reducing stress and promoting well-being.
            </p>
          </li>
          <li>
            <p>
              <strong>Healthier Environment</strong>
              <br />
              We use specialized products and techniques promoting a healthier
              indoor environment for you and your family.
            </p>
          </li>
          <li>
            <p>
              <strong>Professional Expertise</strong>
              <br />
              We have the training, experience, and equipment to efficiently
              clean your home, ensuring high-quality results.
            </p>
          </li>
          <li>
            <p>
              <strong>Customized Cleaning Plans</strong>
              <br />
              We offer custom plans tailored to your specific needs and
              preferences, allowing you to focus on your priority.
            </p>
          </li>
          <li>
            <p>
              <strong>Peace of Mind</strong>
              <br />
              Knowing that your home is being cleaned and maintained by trusted
              professionals can provide peace of mind.
            </p>
          </li>
        </ul>
      </div>
    </section>
  </>
);